import type { Branded } from '@/utils/typing/branded.type';
import type { UserId } from './User.interface';
export interface DmsFile {
    fileId: DmsFileId;
    fileTypeId: DmsFileTypeId;
    extension: string;
    fileName: string;
    url: string;
    size: number;
    lastUpdatedBy: UserId;
    lastUpdatedAt: string;
}

export type DmsFileId = Branded<number, 'DmsFileId'>;
export type DmsFileTypeId = Branded<number, 'DmsFileTypeId'>;

export enum ConflictResolutionStrategy {
    NONE = 'NONE',
    CANCEL = 'CANCEL',
    REPLACE = 'REPLACE',
    KEEP_BOTH = 'KEEP_BOTH'
}
